import { useQuery } from "@tanstack/react-query";

import { ToastService } from "@shared/lib/services";
import { useEffect } from "react";
import { BackednResponse } from "@shared/lib/types";
import { AgencyService } from "../services/agency.service";
import {
  AGENCY_EMPLOYEE_LIST_QUERY_KEY,
  AGENCY_LIST_QUERY_KEY,
  AGENCY_PERMISSIONS_QUERY_KEY,
} from "../constants/querykeys";

export function useGetAgencyPermissions() {
  const { data, isLoading, isError, error } = useQuery<
    BackednResponse<string[]>
  >({
    queryKey: [...AGENCY_PERMISSIONS_QUERY_KEY],
    queryFn: () => AgencyService.getAgencyPermissions(),
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    agencyPermissions: data?.data || [],
    isError,
    isFetching: isLoading,
  };
}
